module.exports = __webpack_public_path__ + "static/Chilecompra_Implementación_Azure_DevOps – 1-fee53a9db3cd9dc1a79e4a7a073d445b.png";